import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'awardsFilter'
})
export class AwardsFilterPipe implements PipeTransform {

  transform(values: any[], searchTerm: string): any {
    if (!values || !searchTerm) {
      return values;
    }

    return values.filter(folder => {
      if (folder.rule && folder.rule.RuleName) {
        return folder.rule.RuleName.toLowerCase().includes(searchTerm.toLowerCase());
      }
      return false;
    });
  }
}
